var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";
import scrollto from "../Utils/scrollTo";
import throttle from "../Utils/throttle";
import noop from "../Utils/noop";
import addEventlistener from "rc-util/lib/Dom/addEventListener.js";
import { ConfigConsumer } from "../Config";

var getDefaultContainer = function getDefaultContainer() {
  return window;
};

var Backtop =
/** @class */
function (_super) {
  __extends(Backtop, _super);

  function Backtop(props) {
    var _this = _super.call(this, props) || this;

    _this.renderBacktop = function (_a) {
      var getPrefixCls = _a.getPrefixCls;
      var _b = _this.props,
          className = _b.className,
          children = _b.children,
          customizePrefixCls = _b.prefixCls,
          style = _b.style;
      var prefixCls = getPrefixCls("", customizePrefixCls);

      var bStyle = __assign(__assign({}, style), {
        display: _this.state.show ? "block" : "unset"
      });

      return _this.state.show && React.createElement("div", {
        className: className ? prefixCls + "-backtop " + className : prefixCls + "-backtop",
        style: bStyle,
        onClick: _this.handleClick
      }, children);
    };

    _this.state = {
      show: false
    };
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.handleScroll = throttle(_this.handleScroll, 100);
    return _this;
  }

  Backtop.prototype.componentDidMount = function () {
    var _a = this.props,
        _b = _a.getContainer,
        getContainer = _b === void 0 ? getDefaultContainer : _b,
        displayHeight = _a.displayHeight;
    this.scrollContainer = getContainer();
    var top = 0;

    if (this.scrollContainer === window) {
      top = window.pageYOffset;
    } else if (this.scrollContainer) {
      top = this.scrollContainer.scrollTop;
    }

    this.setState({
      show: displayHeight ? top > displayHeight : false
    });
    this.scrollEvent = addEventlistener(this.scrollContainer, "scroll", this.handleScroll);
  };

  Backtop.prototype.componentWillUnmount = function () {
    if (this.scrollEvent) {
      this.scrollEvent.remove();
    }
  };

  Backtop.prototype.handleScroll = function () {
    var _a = this.props,
        onToggle = _a.onToggle,
        displayHeight = _a.displayHeight;
    var top = 0;

    if (this.scrollContainer === window) {
      top = window.pageYOffset;
    } else if (this.scrollContainer) {
      top = this.scrollContainer.scrollTop;
    }

    var isShow = !!(displayHeight && top > displayHeight);
    this.setState({
      show: isShow
    });
    onToggle && onToggle(isShow);
  };

  Backtop.prototype.handleClick = function (e) {
    var _a = this.props,
        smooth = _a.smooth,
        duration = _a.duration;

    if (smooth) {
      scrollto(0, 0, {
        duration: duration
      }, noop, this.scrollContainer);
    } else {
      this.scrollContainer.scrollTo(0, 0);
    }

    this.props.onClick && this.props.onClick(e);
  };

  Backtop.prototype.render = function () {
    return React.createElement(ConfigConsumer, null, this.renderBacktop);
  };

  Backtop.defaultProps = {
    className: "",
    displayHeight: 400,
    duration: 1000,
    onClick: noop,
    onToggle: noop,
    smooth: true,
    style: {},
    getContainer: getDefaultContainer
  };
  return Backtop;
}(React.PureComponent);

export default Backtop;